import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $color?: string }>`
	position: relative;
	grid-column: span 3;
	border-radius: 5px;
	background: linear-gradient(
		90deg,
		#17312f 0%,
		${(props) => props.$color} 100%
	);
	overflow: hidden;
	transition: background-color 0.3s ease;
`;

const StyledBannerContent = styled.div`
	position: relative;
	height: 100%;
	padding: 0 80px 0 90px;
	transition: opacity 0.3s ease;

	&.case-enter {
		opacity: 0;
	}

	&.case-enter-active,
	&.case-enter-done,
	&.case-exit {
		opacity: 1;
	}

	&.case-exit-active {
		opacity: 0;
	}
`;

const StyledLeftContainer = styled.div`
	position: relative;
	height: 100%;
	padding-top: 30px;

	${Text}:not(button > ${Text}) {
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
	}
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	bottom: 30px;
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledButton = styled.div`
	padding: 12px 20px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	cursor: pointer;

	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledDot = styled.div`
	width: 6px;
	min-width: 6px;
	height: 6px;
	background-color: #ffffff;
	opacity: 0.1;
	border-radius: 6px;
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 13px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledCaseImg = styled.img`
	position: absolute;
	top: 0;
	right: 80px;
	width: 240px;
	height: 240px;
	user-select: none;
	pointer-events: none;
`;

const StyledCaseImageContainer = styled.div`
	position: absolute;
	width: 240px;
	height: 240px;
	top: 0;
	right: 80px;
	user-select: none;
	pointer-events: none;
`;

const StyledCaseBgContainer = styled.div`
	position: absolute;
	width: 512px;
	height: 512px;
	top: -100px;
	right: -70px;
	opacity: 0.05;
	user-select: none;
	pointer-events: none;

	transition: opacity 0.3s ease;

	&.case-enter {
		opacity: 0;
	}

	&.case-enter-active,
	&.case-enter-done,
	&.case-exit {
		opacity: 0.05;
	}

	&.case-exit-active {
		opacity: 0;
	}
`;

const StyledCaseBg = styled.img`
	position: absolute;
	width: 512px;
	height: 512px;
	top: -100px;
	right: -70px;
	opacity: 0.05;
	user-select: none;
	pointer-events: none;
	transition: opacity 0.3s ease;

	&.case-enter {
		opacity: 0;
	}

	&.case-enter-active,
	&.case-enter-done,
	&.case-exit {
		opacity: 0.05;
	}

	&.case-exit-active {
		opacity: 0;
	}
`;

const StyledSideButton = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 40px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: 16px;
		height: 16px;
		transition: opacity 0.3s ease;
		user-select: none;
		pointer-events: none;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

export {
	StyledBannerContent,
	StyledBottomContainer,
	StyledButton,
	StyledCaseBg,
	StyledCaseBgContainer,
	StyledCaseImageContainer,
	StyledCaseImg,
	StyledContainer,
	StyledDot,
	StyledLeftContainer,
	StyledSideButton,
	StyledTimerContainer,
};
